/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Verify_Get_New_LinkInputs */



/**
* | output |
* | --- |
* | "Get a New Link" |
*
* @param {Auth_Verify_Get_New_LinkInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const auth_verify_get_new_link = /** @type {((inputs?: Auth_Verify_Get_New_LinkInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Verify_Get_New_LinkInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Obtenir un nouveau lien")
	if (locale === "es") return /** @type {LocalizedString} */ ("Obtener un enlace nuevo")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Obter um Novo Link")
	if (locale === "it") return /** @type {LocalizedString} */ ("Ottieni un Nuovo Link")
	return /** @type {LocalizedString} */ ("Get a New Link")
});